// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"AuthContext_spinnerContainer__4f34l","spinner":"AuthContext_spinner__gxlHG","spin":"AuthContext_spin__vOkyF"};